<template>
    <div class="container-fluid wrapper-menu-modulo">
        <div id="contenedero-funciones" class="row">
            <div v-for="(funcion,index) in funciones" :key="index" class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pt-3 pl-2 pr-2">
                <div @click="cambiarDeVista(funcion)" id="contenedor-modulo-info" class="area col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div id="modulo-info" class="form-group align-middle text-center">
                        <i :class="[obtenerIconoDeFuncion(funcion)]"></i>
                        <h6 class="mt-xs-3 mt-sm-3 mt-md-3 mt-lg-3 align-middle">{{ funcion.Nombre }}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import router from '@/router/index'

export default {
    props: {
        moduloId: Number,
    },
    data() {
        return {
            funcionesDeModulo: [],
            funcionesMostradas: false,
            modulo: null
        }
    },
    methods: {
        obtenerFuncionesDeModulo: function(modulos) {
            if(modulos != null && modulos != undefined && modulos.length > 0) {
                this.funcionesMostradas = true;
                this.modulo = modulos.find(m => m.ModuloId == this.moduloId);
                if(this.modulo != null)
                    this.funcionesDeModulo = this.modulo.Funciones;
                else
                    this.funcionesDeModulo = []; 
            }
            else
               this.funcionesDeModulo = []; 
        },
        obtenerIconoDeFuncion: function(funcion) { 
            let icono = 'fas fa-exclamation'
            const { FuncionId, Icono } = funcion;
            if(Icono != null && Icono != undefined && Icono != '' && Icono.replace(/\s/g, '').length)
                return Icono
            
            // en caso de que no tenga icono tomamos el valor del enum
            const MODULO_ENUM = Object.values(enumeraciones.sinoj.modulos).find(m => m.id == this.moduloId);
            if(MODULO_ENUM != null && MODULO_ENUM != undefined) {
                const FUNCION_ENUM = MODULO_ENUM.funciones.find(f => f.id == FuncionId);
                if(FUNCION_ENUM != null && FUNCION_ENUM != undefined) 
                    icono = (FUNCION_ENUM.icono != null && FUNCION_ENUM.icono != undefined && FUNCION_ENUM.icono != '' && FUNCION_ENUM.icono.replace(/\s/g, '').length)
                            ? FUNCION_ENUM.icono : icono;
            }
            return icono;
        },
        cambiarDeVista: function(funcion) {
            const RUTA_VISTA = `${this.modulo.RutaDeAcceso}${funcion.RutaDeAcceso}`;
            router.push({ path: RUTA_VISTA });
        }
    },
    created() {
        if(!this.funcionesMostradas)
            this.obtenerFuncionesDeModulo(this.$store.state.Login_PermisosDelSistema);
    },
    computed: {
        funciones() {
            return this.funcionesDeModulo;
        }
    },
    watch: {
        '$store.state.Login_PermisosDelSistema': function() {
            if(!this.funcionesMostradas)
                this.obtenerFuncionesDeModulo(this.$store.state.Login_PermisosDelSistema);
        }
    }
}
</script>
<style scoped>
.wrapper-menu-modulo .area {
    background-color: var(--gris-pj-100);
    box-shadow: -6px 6px 4px -1px rgba(0,0,0,0.45);
}

.wrapper-menu-modulo h6 {
    color: black;
}


@media screen and (max-width: 1200px) {
    #contenedor-modulo-info h6 {
        font-size: 13px;
    }

    #contenedor-modulo-info {
        height: 150px !important;
    }

    #modulo-info i {
        font-size: 40px !important;
    }
}

@media screen and (max-width: 992px) {
    #contenedor-modulo-info h6 {
         font-size: 10px;
    }

    #contenedor-modulo-info {
        height: 136px !important;
    }

    #modulo-info i {
        font-size: 25px !important;
    }
}

@media screen and (max-width: 768px) {
    #contenedor-modulo-info h6 {
         font-size: 7px;
    }

    #contenedor-modulo-info {
        height: 116px !important;
    }

    #modulo-info i {
        text-align: center !important;
        font-size: 23px !important;
    }
}

@media screen and (max-width: 575px) {
    #contenedor-modulo-info h6 {
         font-size: 16px;
    }

    #contenedor-modulo-info {
        height: 69px !important;
    }

    #modulo-info i {
        font-size: 25px !important;
        margin-right: 10px;
    }

    #modulo-info {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0;
    }
}

#modulo-info i {
    font-size: 60px;
}

#contenedor-modulo-info {
    cursor: pointer;
    height: 166px;
    text-align: center !important;
}

#contenedor-modulo-info:hover, #contenedor-modulo-info:focus {
    background-color: var(--verde-pj);
}

#contenedor-modulo-info:hover h6, .wrapper-menu-modulo:focus i {
    color: #ffff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CMenuModulo.vue